import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'activeAccountItem'
})
export class ActiveAccountItemPipe implements PipeTransform {

    transform(items: any[]): any {

        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => !item.voided);

    }


}
